import { createReducer } from '@reduxjs/toolkit';
import * as actions from '../actions';
import { NotificationsHipaaState } from '../types';

export const hipaaInitialState: NotificationsHipaaState = {
  isFetching: false,
  isSigning: false,
  error: null,
  agreementHtml: '',
  agreementObject: null,
  patient: null
};

const notificationsPreferencesReducer = createReducer(hipaaInitialState, {
  [actions.SET_HIPAA_PATIENT]: (state, action) => {
    state.error = null;
    state.agreementObject = null;
    state.agreementHtml = '';
    state.isFetching = false;
    state.isSigning = false;
    state.patient = action.payload;
  },
  [actions.GET_HIPAA_AGREEMENT]: state => {
    state.isFetching = true;
  },
  [actions.GET_HIPAA_AGREEMENT_SUCCESS]: (state, action) => {
    state.isFetching = false;
    state.agreementHtml = action.payload.data[0].document;
    state.agreementObject = action.payload.data[0].documentObject;
  },
  [actions.GET_HIPAA_AGREEMENT_FAIL]: (state, action) => {
    state.isFetching = false;
    state.error = action.error;
  },
  [actions.SIGN_HIPAA_AGREEMENT]: state => {
    state.isSigning = true;
  },
  [actions.SIGN_HIPAA_AGREEMENT_SUCCESS]: state => {
    if (state) state.isSigning = false;
  },
  [actions.SIGN_HIPAA_AGREEMENT_FAIL]: (state, action) => {
    state.isSigning = false;
    state.error = action.error;
  }
});

export default notificationsPreferencesReducer;
